import React from "react"
import { Link } from "gatsby"
import GrowImg from "../../images/grown.svg"
import WorkWithImg from "../../images/work-with-us.svg"
//import UserTestimonio from "../../images/user-testimonio.png"
import ComillasBlack from "../../images/comillas-black.png"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-20 px-6 pb-20">
      <div className="flex flex-col-reverse md:flex-row items-center pb-20">
        <div className="flex-1 md:w-1/2 md:pr-4">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Grow</span>
            with us
          </h1>
          <h3 className="text-3xl pb-8">
            Are you ready to embark on this journey?
          </h3>
          <p className="text-2xl pb-2">
            We are constantly searching for talent to add to the team.
          </p>
          <p className="text-2xl pb-12">
            <b>Be part of the Avalith adventure</b>.
          </p>
          <Link
            to="/careers/open-seat"
            className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Lets Do It
          </Link>
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img
            src={GrowImg}
            alt="¿Estás listo para emprender el viaje?"
            className="mx-auto"
            width="500"
          />
        </div>
      </div>

      {/* Why work with us? */}
      <div className="flex flex-col md:flex-row items-center pb-20">
        <div className="w-full md:w-1/2 pb-8">
          <img src={WorkWithImg} alt="Why work with us?" className="mx-auto" />
        </div>
        <div className="w-full md:w-1/2 md:px-8">
          <h4 className="text-5xl pb-8 font-normal leading-tight">
            <span className="text-secondary block font-bold">Why</span> work
            with us?
          </h4>
          <h5 className="text-2xl pb-8 font-medium">
            Improve your skills and boost your genius.
          </h5>
          <p className="pb-8">
            <b>We want AVALITH to be the place where you enhance your skills</b>
            , learn from your peers and discover everything you are capable of
            achieving.
          </p>
          <Link
            to="/careers/open-seat"
            className="mx-auto lg:mr-5 lg:mx-0 mb-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Open positions
          </Link>
        </div>
      </div>

      {/* Testimonios */}
      <div className="flex flex-col-reverse md:flex-row items-center xl:w-3/4 xl:mx-auto">
        <div className="w-full flex flex-col">
          <div className="flex flex-row text-center md:text-right">
            <div className="hidden md:block">
              <img
                src={ComillasBlack}
                alt="Laura Komit"
                className="float-right pr-4"
              />
            </div>
            <div className="w-full text-xl">
              <p className="text-center md:text-right pb-4">
                About Avalith I like that the professionals are of a high
                quality, both technical and human. I also like that teamwork is
                not a theory but a day-to-day practice.
              </p>
              <h3 className="text-2xl pb-2 italic">
                Mara Ximena Falconí Abad, <b>RRHH</b>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
